import { Linkedin, Twitter, Facebook, Share2 } from "lucide-react";

/**
 * Show share buttons after a user completes a chapter.
 * Each share post links back to the site and includes the referral code if present.
 */
export default function MilestoneShare({ chapterId, chapterTitle, totalChapters = 9, referralCode }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const link = referralCode ? `${origin}/?ref=${referralCode}` : origin;
  const text = `Just completed Step ${chapterId} of ${totalChapters} (${chapterTitle}) on my Texas LLC formation journey! 🚀`;

  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}&title=${encodeURIComponent("Texas LLC Formation Progress")}&summary=${encodeURIComponent(text)}`;
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text + " " + link)}`;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}&quote=${encodeURIComponent(text)}`;

  return (
    <div
      data-testid={`milestone-share-${chapterId}`}
      className="rounded-xl border-2 border-[#A3E6D5] bg-[#A3E6D5]/15 p-5 shadow-[3px_3px_0px_var(--c-shadow)]"
    >
      <div className="flex items-start gap-3">
        <Share2 className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#1E3A8A]" />
        <div className="flex-1">
          <p className="font-heading text-sm font-bold uppercase tracking-wider text-[var(--c-text)]">
            Step {chapterId} complete — share your progress
          </p>
          <p className="mt-1 text-sm text-[var(--c-text)]">
            Inspire other Texas entrepreneurs &mdash; share this milestone with your network.
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            <a
              data-testid={`milestone-linkedin-${chapterId}`}
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 rounded-full border-2 border-[#0A66C2]/40 bg-[#0A66C2]/5 px-3 py-1.5 text-xs font-bold text-[#0A66C2] transition-all hover:-translate-y-0.5 hover:bg-[#0A66C2]/10 hover:shadow-[2px_2px_0px_var(--c-shadow)]"
            >
              <Linkedin className="h-3.5 w-3.5" />
              LinkedIn
            </a>
            <a
              data-testid={`milestone-twitter-${chapterId}`}
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 rounded-full border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-3 py-1.5 text-xs font-bold text-[var(--c-text)] transition-all hover:-translate-y-0.5 hover:shadow-[2px_2px_0px_var(--c-shadow)]"
            >
              <Twitter className="h-3.5 w-3.5" />
              X / Twitter
            </a>
            <a
              data-testid={`milestone-facebook-${chapterId}`}
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 rounded-full border-2 border-[#1877F2]/40 bg-[#1877F2]/5 px-3 py-1.5 text-xs font-bold text-[#1877F2] transition-all hover:-translate-y-0.5 hover:bg-[#1877F2]/10 hover:shadow-[2px_2px_0px_var(--c-shadow)]"
            >
              <Facebook className="h-3.5 w-3.5" />
              Facebook
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
